import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '../../../../shared/state/settings/settings.service';
import { CompanyService } from '../../../../shared/state/company/company.service';
import { ClinicDetailService } from '../../../../shared/state/clinic-detail/clinic-detail.service';
import { IonContent, ModalController, NavController } from '@ionic/angular';
import { FlowwerInitializaterComponent } from '../../../../shared/components/flowwwer-initializater-component/flowwwer-initializater-component';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { UserService } from '../../../../shared/state/user/user.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { UserRegisterModel } from '../../../../shared/models/userRegister.model';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { LibraryService } from '../../../../core/services/library/library.service';
import { UserQuery } from '../../../../shared/state/user/user.query';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { RegisterFormComponent } from '../../../../shared/components/register-form/register-form.component';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { RouterService } from '../../../../core/services/router/router.service';
import {
    OtpModalComponent,
    OTPModalDismissActions,
} from '../../../../shared/components/otp-modal/otp-modal.component';
import { ClientDataSocialLogin } from '../../../../shared/state/social-login/social-login.store';
import { SocialLoginQuery } from '../../../../shared/state/social-login/social-login.query';
import { SocialLoginService } from '../../../../shared/state/social-login/social-login.service';
import {
    fade_in,
    fade_out,
    fade_out_absolute,
} from 'src/app/core/animations/fade';
import { Keyboard } from '@capacitor/keyboard';

@Component({
    selector: 'app-register',
    animations: [fade_in, fade_out, fade_out_absolute],
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    host: { class: 'ion-page-without-padding' },
})
/**TODO: Plantilla de como creo que es el mejor skeleton CON FOOTER.
 * De esta forma, la animación es la mas simple y los estilos se usan en archivos scss
 * que admiten mas versatilidad.
 * Se usan estilos absolutos en el propio skeleton para simular el contenedor al que sustituyen de forma absoluta
 * Se simulan paddings también porque se situa en top:0 left:0
 * En este caso, con el footer se usa primero estilos relativos, y se usa el fade_out_absolute para cambiarse cuando aparece el otro
 * Ver como mejorar esto porque cada caso lo hago de una forma y es un jaleo
 */
export class RegisterComponent
    extends FlowwerInitializaterComponent
    implements OnInit, OnDestroy {

    @HostListener("click", ["$event.target"])
    onFocus(target) {
        console.log('HostListener');
        console.log('Target',target);
        this.lastFocus = target;
        
    }
    @ViewChild(IonContent) content: IonContent;

    systemKeyUrl: Observable<string>;
    clinicDetailId$: Observable<string>;
    clinicDetailRgpdDisable$: Observable<boolean>;

    @ViewChild(RegisterFormComponent)
    registerFormComponent: RegisterFormComponent;

    keyboardIsShowing: Observable<boolean>;
    clientDataSocialLogin: ClientDataSocialLogin;

    /** flowwwer template */
    clinicName$: Observable<string>;
    isGeneric$: Observable<boolean>;

    private lastFocus: any;
    private scrollEvent$: Subscription;

    constructor(
        private toastService: ToastService,
        private companyQuery: CompanyQuery,
        private loadingService: LoadingService,
        private keyboardQuery: KeyboardQuery,
        private modalController: ModalController,
        private socialLoginQuery: SocialLoginQuery,
        private socialLoginService: SocialLoginService,
        libraryService: LibraryService,
        clinicDetailQuery: ClinicDetailQuery,
        companyService: CompanyService,
        activatedRoute: ActivatedRoute,
        settingsService: SettingsService,
        clinicDetailService: ClinicDetailService,
        navCtrl: NavController,
        userService: UserService,
        settingsQuery: SettingsQuery,
        userQuery: UserQuery,
        routerService: RouterService
    ) {
        super(
            activatedRoute,
            settingsService,
            userService,
            companyService,
            clinicDetailService,
            navCtrl,
            clinicDetailQuery,
            settingsQuery,
            userQuery,
            libraryService,
            routerService
        );
    }

    async ngOnInit(): Promise<void> {
        this.systemKeyUrl = this.settingsQuery.select('systemKeyURL');
        this.clinicDetailId$ = this.clinicDetailQuery.select('id');
        this.clinicDetailRgpdDisable$ = this.clinicDetailQuery.select(
            'RGPDDisable'
        );
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.isLoadingContent = true;
        try {
            await this.initializeCompanyClinicUser(true);
        } catch (error) {
            this.isLoadingContent = false;
        }

        this.clientDataSocialLogin = this.socialLoginQuery.getValue().clientData;
        this.isLoadingContent = false;

        /** flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.isGeneric$ = this.settingsQuery.selectIsGeneric();

        this.scrollEvent$ = fromEvent(window, 'keyboardDidShow').subscribe( e =>{
            if (this.lastFocus && this.content) {
                const offsetY = 128;
                const rect = this.lastFocus.getBoundingClientRect();
                const desplazamientoY = (rect.top) - offsetY;
                this.content.scrollToPoint(0, desplazamientoY, 300);
            }
        });
    }

    async submit() {
        if (this.registerFormComponent.registerForm.invalid) {
            Object.values(
                this.registerFormComponent.registerForm.controls
            ).forEach((control) => {
                control.markAsTouched();
            });
            return;
        }

        /** Validaciones adicionales de checkboxes */
        if (!this.registerFormComponent.userEnableGeneralConditions) {
            this.toastService.presentErrorToast(
                this.libraryService.getLabel('app_privacy_policy_mandatory')
            );
            return;
        }

        const userRegister: UserRegisterModel = {
            name: this.registerFormComponent.registerForm.value.userName,
            surname1: this.companyQuery.nameSplit
                ? this.registerFormComponent.registerForm.value.userSurname1 ??
                  ''
                : '',
            surname2: this.companyQuery.nameSplit
                ? this.registerFormComponent.registerForm.value.userSurname2 ??
                  ''
                : '',
            phone:
                this.registerFormComponent.registerForm.value.userPhone ?? '',
            email:
                this.registerFormComponent.registerForm.value.userEmail ?? '',
            referrerCode:
                this.registerFormComponent.registerForm.value
                    .userReferrerCode ?? '',
            enableGeneralConditions: this.registerFormComponent
                .userEnableGeneralConditions,
            enableRgpd: this.clinicDetailQuery.RGPDDisable
                ? true
                : this.registerFormComponent.userEnableRgpd,
        };
        /** Registramos el usuario y lo logeamos en el sistema */
        this.loadingService.updateShowSpinner(true);

        /** OTP: Si no da error, y no se devuelve el clientToken es porque
         * hay que pedir OTP para completar registro */
        const { clientToken, hashCode } = await this.userService.registerUser(
            userRegister
        );
        if (!clientToken) {
            /** Abrimos modal de OTP y esperamos a que se cierre para decidir que hacer */
            const otpModal = await this.modalController.create({
                component: OtpModalComponent,
                componentProps: {
                    hashCode,
                    email: this.registerFormComponent.registerForm.value
                        .userEmail,
                },
            });
            await otpModal.present();
            const { data } = await otpModal.onDidDismiss();
            if (data?.action === OTPModalDismissActions.NONE) {
                return;
            }
        }
        try {
            await this.userService.checkUserAndLoad();

            if (this.companyQuery.clientAdvisor) {
                await this.userService.getReferrerData();
            }
        } catch (e) {
            this.routerService.goToMainTabWithoutLogin();
        }

        this.loadingService.updateShowSpinner(false);

        /** Si puedo mostrar el tab de details redirijo a details, si no a perfil */

        this.navCtrl.navigateBack([
            '/' +
                this.settingsQuery.systemKeyURL +
                '/' +
                this.clinicDetailQuery.id +
                '/details',
        ]);
    }

    goBack() {
        /* E.C.S Se oculta el login social 
            this.navCtrl.navigateBack([
                '/' +
                    this.settingsQuery.systemKeyURL +
                    '/' +
                    this.clinicDetailQuery.id +
                    '/register/social',
            ]); */
            /** Solo puedo volver atrás si no estoy en personalzas o si soy personalizada y tengo más de 1 centro */
            if (
                !this.settingsQuery.browser ||
                this.settingsQuery.showClinicDetails
            ) {
                this.navCtrl.navigateBack([
                    '/' +
                        this.settingsQuery.systemKeyURL +
                        '/' +
                        this.clinicDetailQuery.id +
                        '/details',
                ]);
            } else {
                this.clinicDetailService.resetStore();
                this.navCtrl.navigateBack('/');
            }
    }

    /** Al destruir el componente nos desuscribimos al observable de los parámetros de esta página */
    ngOnDestroy() {
        this.unsuscribeParamsQueryParams();
        this.scrollEvent$.unsubscribe();
    }
}
